import ApiAdmin from './config/ApiAdmin'
import store from '@/store/index'

const GroupsService = {

  getGroups (slug, page, pageSize, search) {
    return ApiAdmin.get(`/organizations/${slug}/groups`,
      {params: {page, page_size: pageSize, search}})
  },

  getGroup (id) {
    return ApiAdmin.get(`/organizations/${store.getters.slug}/groups/${id}`)
  },

  createGroup (group) {
    return ApiAdmin.post(`/organizations/${store.getters.slug}/groups`, group)
  },

  editGroup (group) {
    return ApiAdmin.put(`/organizations/${store.getters.slug}/groups/${group.id}`, group)
  },

  deleteGroup (groupId) {
    return ApiAdmin.delete(`/organizations/${store.getters.slug}/groups/${groupId}`)
  },

  getOrganizationThemes () {
    return ApiAdmin.get(`/organizations/${store.getters.slug}/themes`)
  }

}

export default GroupsService



// WEBPACK FOOTER //
// ./src/services/GroupsService.js